import { RefObject, useRef, useState } from "react";
import styled from "styled-components";
import { useOutsideClick } from "../../../hooks/useOutsideClick";
import { MoreHorizOutlined } from "../../materialUi/materialUi";
import { ButtonDS } from "../Button";
import { MenuOptionsProps, MenuOptions } from "../Menu/MenuOptions";
import { Spacer } from "../Spacer";
import ReactDOM from "react-dom";

export const MenuOptionsCell = <
  Key extends string,
  T extends Record<Key, string | number | null | boolean>,
>(props: {
  id: string;
  menuOptions: MenuOptionsProps<Key, T>;
}) => {
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
  const [bottomRef, setBottomRef] = useState<number>(0);
  const [leftRef, setLeftRef] = useState<number>(0);
  const outsideClickMenuOptions = useOutsideClick(() => {
    setIsMenuVisible(false);
  });
  return (
    <StyledMenuOptionsCell onClick={(event) => event.stopPropagation()}>
      {isMenuVisible &&
        ReactDOM.createPortal(
          <StyledMenuOptionsPanelContainer
            ref={outsideClickMenuOptions}
            style={{
              position: "absolute",
              top: bottomRef + window.scrollY + 8, // value of the spacer
              left: leftRef + window.scrollX - 170, // width of the panel
            }}
          >
            <StyledMenuOptionsPanel>
              <MenuOptions
                hasBorderRow
                options={props.menuOptions.options.map((option) => {
                  return {
                    ...option,
                    isDisabled: () => {
                      return option.isDisabled?.()
                        ? option.isDisabled(props.id)
                        : false;
                    },
                    action: () => {
                      option.action(props.id);
                      !option.isDisabled?.(props.id) && setIsMenuVisible(false);
                    },
                  };
                })}
              />
            </StyledMenuOptionsPanel>
            <Spacer x={2.5} />
          </StyledMenuOptionsPanelContainer>,
          document.body,
        )}
      <Spacer y={1} />
      <MenuOptionsButton
        id={props.id}
        setIsMenuVisible={setIsMenuVisible}
        setBottomRef={setBottomRef}
        setLeftRef={setLeftRef}
        isMenuVisible={isMenuVisible}
        outsideClickMenuOptions={outsideClickMenuOptions}
      />
      <Spacer y={1} />
    </StyledMenuOptionsCell>
  );
};

const MenuOptionsButton = (props: {
  id: string;
  outsideClickMenuOptions: RefObject<HTMLDivElement>;
  isMenuVisible: boolean;
  setIsMenuVisible: (isMenuVisible: boolean) => void;
  setBottomRef: (bottom: number) => void;
  setLeftRef: (left: number) => void;
}) => {
  const buttonRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    if (!buttonRef.current) {
      return;
    }
    const rect = buttonRef.current.getBoundingClientRect();
    props.setIsMenuVisible(true);
    props.setBottomRef(rect.bottom);
    props.setLeftRef(rect.left);
  };

  return (
    <div ref={props.outsideClickMenuOptions}>
      <div ref={buttonRef}>
        <ButtonDS
          style={{ width: "3.5rem" }}
          format="fill"
          buttonType="secondary"
          singleIcon={{ icon: <MoreHorizOutlined />, size: "S" }}
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

const StyledMenuOptionsPanel = styled.div`
  pointer-events: auto;
`;

const StyledMenuOptionsPanelContainer = styled.div`
  pointer-events: none;
`;

const StyledMenuOptionsCell = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: default;
`;
